// extracted by mini-css-extract-plugin
export default {"notiText":"InputField_notiText__S7-5j"};